import React, { useCallback, useState } from 'react';
import { usePurchaseStatus } from '../TileKit/hooks';
import Tooltip from '../Tooltip/Tooltip';
import HoldIcon from './HoldIcon';
import './OnHold.scss';

const tooltip = (
  <>
    <div className="tooltip-title">This Vehicle Is On Hold</div>
    <p className="tooltip-text">
      Another customer recently began the process to purchase this vehicle, so
      we’re holding it for them temporarily, just like we will for you.
      Frequently, customers do not move forward during this hold time and the
      vehicle becomes available again.
    </p>
  </>
);

type BaseOnHoldProps = {
  trackOnHoldClicked: () => void;
};

const OnHold: React.FC<BaseOnHoldProps> = ({ trackOnHoldClicked }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { isOnHold } = usePurchaseStatus();

  const handleTooltipClick = useCallback((ev: MouseEvent) => {
    ev.stopPropagation();

    setShowTooltip(v => {
      if (!v) trackOnHoldClicked();

      return !v;
    });
  }, []);

  return isOnHold ? (
    <div className="onhold purchase-callout" data-qa="on-hold">
      <Tooltip
        component={tooltip}
        open={showTooltip}
        onClick={handleTooltipClick}
      >
        <HoldIcon />
        <span>On hold</span>
      </Tooltip>
    </div>
  ) : null;
};

const TextOnlyOnHold: React.FC<BaseOnHoldProps> = ({ trackOnHoldClicked }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { isOnHold } = usePurchaseStatus();

  const handleTooltipClick = useCallback((ev: MouseEvent) => {
    ev.stopPropagation();

    setShowTooltip(v => {
      if (!v) trackOnHoldClicked();

      return !v;
    });
  }, []);

  return isOnHold ? (
    <div className="onhold purchase-callout text-only" data-qa="on-hold-badge">
      <Tooltip
        component={tooltip}
        onClick={handleTooltipClick}
        open={showTooltip}
        qaName="on-hold"
      >
        <span>On Hold</span>
      </Tooltip>
    </div>
  ) : null;
};

export default OnHold;
export { TextOnlyOnHold };
